import React, { useEffect } from 'react';
import { LocationOnOutlined, PhoneOutlined, FavoriteBorder } from '@mui/icons-material';
import '../styles/common.css';
import '../styles/SeoPages.css';
import goldHeroObj from '../images/gold-jewellery-hero.png';

const WomenJewelleryPage = () => {
    useEffect(() => {
        document.title = "Women Jewellery in Jodhpur | Necklaces, Rings & Earrings – MAB Jewels";
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute("content", "Shop exquisite women's jewellery in Jodhpur. Gold necklaces, diamond rings, bridal sets & daily wear. Handcrafted for elegance at MAB Jewels.");
        }
    }, []);

    return (
        <div className="page-container seo-page">
            <div className="seo-content-wrapper">
                <h1>Women Jewellery in Jodhpur – Elegance Crafted for Her</h1>

                {/* Hero Image */}
                <div className="seo-hero-image-container">
                    <img
                        src={goldHeroObj}
                        alt="Women Jewellery Collection - MAB Jewels"
                        className="seo-hero-image"
                        style={{ width: '100%', borderRadius: '12px', marginBottom: '30px', boxShadow: '0 8px 20px rgba(0,0,0,0.1)' }}
                    />
                </div>

                <p className="seo-intro">
                    Celebrate womanhood with MAB Jewels' exclusive collection of <strong>Women Jewellery in Jodhpur</strong>.
                    Whether it's a wedding, anniversary, or daily wear, we have the perfect piece for you.
                </p>

                <h2>Categories for Every Occasion</h2>
                <ul className="seo-check-list">
                    <li><FavoriteBorder sx={{ color: '#d4af37', mr: 1, fontSize: '1.2rem' }} /> <strong>Bridal Sets:</strong> Complete sets for your special day.</li>
                    <li><FavoriteBorder sx={{ color: '#d4af37', mr: 1, fontSize: '1.2rem' }} /> <strong>Daily Wear:</strong> Lightweight gold & diamond pieces.</li>
                    <li><FavoriteBorder sx={{ color: '#d4af37', mr: 1, fontSize: '1.2rem' }} /> <strong>Traditional:</strong> Jadau, Kundan, and Antique designs.</li>
                    <li><FavoriteBorder sx={{ color: '#d4af37', mr: 1, fontSize: '1.2rem' }} /> <strong>Modern:</strong> Contemporary designs for the modern woman.</li>
                </ul>

                <h2>Experience the Art of Jewellery</h2>
                <p>
                    Our master craftsmen create designs that blend traditional Rajasthani heritage with modern aesthetics.
                    Visit MAB Jewels to try on our exclusive collection.
                </p>

                {/* Local SEO Boost */}
                <div className="local-seo-box">
                    <h3>Contact MAB Jewels</h3>
                    <div className="seo-contact-row">
                        <LocationOnOutlined sx={{ color: '#d4af37', mr: 1 }} />
                        <span>Rajasthan, India</span>
                    </div>
                    <div className="seo-contact-row">
                        <PhoneOutlined sx={{ color: '#d4af37', mr: 1 }} />
                        <span>+91 94148 17620</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WomenJewelleryPage;
